export default {
  Header: {
    Title: 'View Event',
    EditButton: 'Edit',
    RescheduleButton: 'Reschedule',
    CancelButton: 'Cancel Event',
  },
  RescheduleDialogTitle: {
    Title: 'Reschedule Event',
    Date: 'Date',
    StartTime: 'Start Time',
    EndTime: 'End Time',
  },
  DeclineDialogTitle: {
    Title: 'Decline Request',
  },
  ClockOutDialogTitle: {
    Title: 'Clock-Out Event',
  },
  ClockInDialogTitle: {
    Title: 'Clock-In Event',
  },
  AcceptRescheduleDialog: {
    Title: 'Accept Reschedule Request',
    Description: 'Are you sure you want to accept this request to reschedule this shift?',
  },
  AcceptCancelDialog: {
    Title: 'Accept Cancellation Request',
    Description: 'Are you sure you want to accept this request to cancel this shift?',
  },
  UserSection: {
    Caregiver: {
      Title: 'Caregiver',
      NoCaregiver: 'No caregiver assigned to this shift.',
      ChangeCaregiver: 'Change Caregiver',
    },
    Client: {
      Title: 'Client',
      NoClient: 'No client assigned to this shift.',
    },
    NoEmail: 'No email provided',
    NoPhone: 'No phone provided',
  },
  TimeSection: {
    Title: 'Time',
    hour: 'hour',
    hours: 'hours',
    Minutes: ' #{breakDuration} minutes',
    Breaks: ' #{breakCount} breaks',
    TotalBreakTime: '#{totalBreakTime} minutes',
    BreakDetails: '#{breakCount} Break × #{breakDuration} minutes',
  },
  NotesSection: {
    Title: 'Notes',
    AddNoteButton: 'Edit Note',
    NoNotes: 'No notes available for this shift.',
    SaveForAllButton: 'Save for All',
  },
  ReimbursementSection: {
    Title: 'Expenses',
  },
  EventTimelineSection: {
    Title: 'Event Timeline',
    ShiftConfirmed: {
      Title: 'Shift Confirmed ',
      Description: '#{caregiverName} confirmed this shift',
    },
    ShiftClockedIn: {
      Title: 'Clocked In ',
      Description: '#{caregiverName} clocked in',
      ClockinTime: 'Clock-In Time',
      EditedClockinTime: 'Edited Clock-In Time',
      EditClockinButton: 'Edit Clock-In Time',
      Location: 'Location',
      NoLocation: 'No Location',
      Notes: 'Notes',
      NoNotes: 'No Additional Notes',
    },
    ShiftClockedOut: {
      Title: 'Clocked Out ',
      Description: '#{caregiverName} clocked out',
      ClockoutTime: 'Clock-Out Time',
      EditedClockoutTime: 'Edited Clock-Out Time',
      EditClockoutButton: 'Edit Clock-Out Time',
      Location: 'Location',
      NoLocation: 'No Location',
      Notes: 'Notes',
      NoNotes: 'No Additional Notes',
      CareviewSummary: 'Careview Summary',
      NoAnswer: 'No answer provided',
    },
    ShiftConfirmationMissed: {
      Title: 'Missed Shift Confirmation',
      Description: '#{caregiverName} missed confirming this shift',
    },
    ShiftClockInMissed: {
      Title: 'Missed Clock-In',
      Description: '#{caregiverName} missed clocking in for this shift',
    },
    ShiftClockOutMissed: {
      Title: 'Missed Clock-Out',
      Description: '#{caregiverName} missed clocking out for this shift',
    },
    ShiftRescheduled: {
      DeactivatedTitle: 'Event Rescheduled',
      DeactivatedDescription: 'This event has been rescheduled. View the new event details below.',
      ViewNewEvent: 'View New Event',
    },
    ShiftRequestedReschedule: {
      Title: 'Requesting To Reschedule',
      Description: '#{caregiverName} is requesting to reschedule this event to #{date} at #{time}.',
      Reason: 'Reason for Rescheduling Shift: ',
      NoReason: 'No reason mentioned',
      RequestDeclined: 'Request Declined',
    },
    ShiftCancelled: {
      DeactivatedTitle: 'Event Cancelled',
      DeactivatedDescription: 'The request to cancel this event has been accepted.',
    },
    ShiftRequestedCancel: {
      Title: 'Requesting To Cancel',
      Description: '#{caregiverName} is requesting to cancel this event.',
      Reason: ' Reason for Rejecting Shift: ',
      NoReason: 'No reason mentioned',
      RequestDeclined: 'Request Declined',
    },
    RecordCreation: {
      Title: 'Record Created ',
      Description: 'This event has been created.',
    },
  },
  Reason: {
    Reason: 'Reason',
    ReasonForCancel: 'Enter reason for cancellation..',
    ReasonForReschedule: 'Enter reason for rescheduling..',
    ReasonForCaregiver: 'Enter reason for changing caregiver..',
  },
  Styles: {
    ShiftConfirmation: 'Confirmed',
    ClockInConfirmation: 'Clocked In',
    ClockOutConfirmation: 'Clocked Out',
    ShiftConfirmationMissed: 'Missed Confirmation',
    ClockInConfirmationMissed: 'Missed Clock In',
    ClockOutConfirmationMissed: 'Missed Clock Out',
    Unconfirmed: 'Unconfirmed',
    RequestedReschedule: 'Requested Reschedule',
    RequestedCancel: 'Requested Cancellation',
    Cancelled: 'Cancelled',
    Rescheduled: 'Rescheduled',
    LiveIn: 'Live In',
  },
};
